<template>
	<div id="app" v-if="!pageIsLoading">
		<AdminBar v-if="showAdminBar" />
		<ThemeHeader />
		<template v-if="!is404">
			<transition name="opacity">
				<router-view :key="key" />
			</transition>
		</template>
		<template v-else>
			<Page404 />
		</template>
		<ThemeFooter />
	</div>
	<div v-else>Loading ...</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { getCookie, setCookie } from '@/helpers'
import ThemeHeader from '@/components/ThemeHeader'
import ThemeFooter from '@/components/ThemeFooter'
const AdminBar = () => import('@/components/AdminBar')
const Page404 = () => import('@/views/Page404')

export default {
	name: 'NHK',
	components: {
		ThemeHeader,
		ThemeFooter,
		AdminBar,
		Page404,
	},
	mounted() {
		this.removeNotUpdatingMeta()
		const VM = this
		if (VM.isPreview(VM.$route)) {
			VM.loadPreview()
		} else {
			VM.loadFrontPage()
		}

		//console.log(VM.currentPage)
		//VM.loadFrontPage();
	},
	created() {
		const cookieDarkMode = getCookie('dark-theme')
		const systemDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

		/* 100 VH fix */
		document.querySelector(':root').style.setProperty('--vh', window.innerHeight / 100 + 'px')
		window.addEventListener('resize', () => {
			document.querySelector(':root').style.setProperty('--vh', window.innerHeight / 100 + 'px')
		})

		if ((systemDark && cookieDarkMode !== 'false') || cookieDarkMode === 'true') {
			const setOption = {
				set: true,
				cookies: false,
			}
			this.DARK_MODE(setOption)
		}
	},
	data() {
		return {
			is404: false,
			wpvue: window.WPVUE,
			frontPageLoaded: false,
			pageIsLoading: true,
			showAdminBar:
				process.env.NODE_ENV === 'development'
					? true
					: window.WPVUE && window.WPVUE.user && window.WPVUE.user.show_bar
					? true
					: false,
		}
	},
	computed: {
		...mapGetters([
			'currentPostType',
			'currentPage',
			'currentPageID',
			'searchModalOpen',
			'mainNaviIsOpen',
			'isFrontPage',
		]),
		key() {
			return this.currentPageID
		},
		shareImage() {
			let image = {
				url: '',
				width: '',
				height: '',
			}
			let tmpImage = null
			if (this.currentPage) {
				if (this.currentPage.acf && this.currentPage.acf.seo_facebook_image) {
					tmpImage =
						this.currentPage.acf.seo_facebook_image.sizes &&
						this.currentPage.acf.seo_facebook_image.sizes.extra_large
							? this.currentPage.acf.seo_facebook_image.sizes.extra_large
							: this.currentPage.acf.seo_facebook_image.sizes.full
				} else if (this.currentPage.featured_image) {
					tmpImage =
						this.currentPage.featured_image.sizes && this.currentPage.featured_image.sizes.extra_large
							? this.currentPage.featured_image.sizes.extra_large
							: this.currentPage.featured_image.sizes.full
				}
			}
			if (tmpImage) {
				image = {
					url: tmpImage.url,
					width: tmpImage.width,
					height: tmpImage.height,
				}
			}
			return image
		},
		pageDescription() {
			let desc = this.wpvue ? this.wpvue.blogdescription : ''
			if (this.currentPage) {
				desc =
					this.currentPage.acf && this.currentPage.acf.seo_description
						? this.currentPage.acf.seo_description
						: this.currentPage.excerpt
			}
			return desc
		},
	},
	watch: {
		$route(to, from) {
			const VM = this
			if (to.path !== from.path) {
				if (VM.mainNaviIsOpen || VM.searchModalOpen) {
					setTimeout(() => {
						VM.hideAnyOpenMenu()
					}, 100)
				}
			}
			if (process.env.NODE_ENV === 'development') {
				//console.log('%c Route To: ', 'font-weight: bold; color: #731853');
				//console.table([to])
			}
			//load Preview

			if (VM.isPreview(to)) {
				VM.loadPreview()
			} else {
				VM.is404 = false
				if (window.location.pathname !== '/') {
					VM.loadPageByRoute()
				} else {
					VM.loadFrontPage()
				}
			}

			//this.loadFrontPage();
		},
		mainNaviIsOpen(val) {
			if (val) {
				document.getElementsByTagName('html')[0].classList.add('search-open')
			} else {
				document.getElementsByTagName('html')[0].classList.remove('search-open')
			}
		},
		searchModalOpen(val) {
			if (val) {
				document.getElementsByTagName('html')[0].classList.add('search-open')
			} else {
				document.getElementsByTagName('html')[0].classList.remove('search-open')
			}
		},
		pageIsLoading(val) {
			if (!val) {
				//console.log('%c LOADING VALUE: '+val, 'font-weight: bold; color: orange');
				this.$nextTick(() => {
					this.loadTaxonomies()
					const preloader = document.getElementById('preloader-page')
					if (preloader) document.getElementById('preloader-page').classList.add('loaded')
				})
			}
		},
		// hash scroll
		/* currentPage(val){
			if(val){
				this.$nextTick(() => {
					if(window.location.hash){
						const hash = location.hash.substring(1);
						const el = document.getElementById(hash);
						if(el) $('html, body').animate({scrollTop: el.offsetTop + 20} ,450);
					}  
				})
			}
		} */
	},
	methods: {
		...mapActions(['getPost', 'getTaxonomy']),
		...mapMutations(['MENU_OPEN_CHANGE_STATE', 'SEARCH_MODAL_CHANGE_STATE', 'DARK_MODE']),
		hideAnyOpenMenu() {
			if (this.mainNaviIsOpen) {
				this.MENU_OPEN_CHANGE_STATE()
			}
			if (this.searchModalOpen) {
				this.SEARCH_MODAL_CHANGE_STATE()
			}
		},
		loadTaxonomies() {
			const VM = this
		},
		async loadPageByRoute() {
			const VM = this

			if (VM.currentPage && VM.currentPage.id) return

			return await VM.getPost().then((res) => {
				if (VM.pageIsLoading) VM.pageIsLoading = false
				if ((!res.data || !res.data.posts || !res.data.posts.length) && window.location.pathname !== '/404') {
					VM.is404 = true
				} else {
					VM.is404 = false
				}
			})
		},
		isPreview(route) {
			return route && route.query && route.query.preview === 'true' && route.query.nonce && route.query.post_id
		},
		loadPreview() {
			const VM = this
			const route = VM.$route
			if (!route) return false
			VM.getPost({
				action: 'preview',
				cache: new Date().getTime(),
				nonce: route.query.nonce,
				id: route.query.post_id,
				featured: route.query.featured,
			}).then(() => {
				if (VM.pageIsLoading) VM.pageIsLoading = false
			})
		},
		loadFrontPage() {
			const VM = this
			if (!VM.wpvue) return null
			//console.log(VM.currentPage)
			if (VM.currentPage && VM.currentPage.id) return
			const { page_on_front } = VM.wpvue
			if (
				!VM.frontPageLoaded &&
				window.location.pathname === '/' &&
				page_on_front &&
				window.location.pathname !== '/404'
			) {
				VM.getPost({ id: page_on_front, type: 'page' }).then(() => {
					if (VM.pageIsLoading) VM.pageIsLoading = false
					VM.frontPageLoaded = true
					VM.is404 = false
				})
			}
		},
		removeNotUpdatingMeta() {
			const toRemove = [
				'meta[name=robots]',
				'meta[name=googlebot]',
				'meta[name=description]',
				'meta[name=keywords]',
				'meta[name=author]',
				'meta[property="og:title"]',
				'meta[property="og:description"]',
				'meta[property="og:url"]',
				'meta[property="og:site_name"]',
				'meta[name="twitter:title"]',
				'meta[name="twitter:description"]',
			]
			toRemove.forEach((element) => {
				let item = document.head.querySelector(element)
				if (item) item.remove()
			})
		},
		pageTitle() {
			let title = ''
			if (this.currentPage) {
				title =
					this.currentPage.acf && this.currentPage.acf.seo_title
						? this.currentPage.acf.seo_title
						: this.currentPage.title
			} else {
				title = this.$route.meta && this.$route.meta.title ? this.$route.meta.title : ''
			}
			return title
		},
		noIndex() {
			let noIndex = false
			if (this.currentPage && this.currentPage.acf) {
				noIndex = this.currentPage.acf.seo_no_index === true
			}
			return noIndex
		},
		pageKeywords() {
			let keywords = ''
			if (this.currentPage) {
				keywords =
					this.currentPage.acf && this.currentPage.acf.seo_keywords ? this.currentPage.acf.seo_keywords : ''
			}
			return keywords
		},
		SEOTemplate(title) {
			if (window.location.pathname === '/') return '%s - ' + title
			else return title + ' - %s'
		},
	},
	metaInfo() {
		const VM = this
		const title = VM.pageTitle()
		const pageTitle = VM.wpvue ? VM.wpvue.blogname : 'NHK'
		const canIndex = !VM.noIndex()
		return {
			title: pageTitle,
			titleTemplate: VM.SEOTemplate(title),
			htmlAttrs: {
				lang: 'no',
			},
			/* link: [
					{ rel: 'canonical', href: (VM.getCurrentPageMeta)? (VM.getCurrentPageMeta.url) : window.location.href },
				], */
			meta: [
				{
					vmid: 'description',
					name: 'description',
					content: VM.pageDescription,
				},
				{
					vmid: 'robots',
					name: 'robots',
					content: canIndex ? 'all' : 'noindex',
				},
				{
					vmid: 'googlebot',
					name: 'googlebot',
					content: canIndex ? 'all' : 'noindex',
				},
				{
					vmid: 'keywords',
					name: 'keywords',
					content: VM.pageKeywords(),
				},
				{
					vmid: 'og:title',
					property: 'og:title',
					content: pageTitle + ' - ' + title,
				},
				{
					vmid: 'og:description',
					property: 'og:description',
					content: VM.pageDescription,
				},
				{
					vmid: 'og:url',
					property: 'og:url',
					content: window.location.href,
				},
				{
					vmid: 'og:image',
					property: 'og:image',
					content: VM.shareImage.url,
				},
				{
					vmid: 'og:image:width',
					property: 'og:image:width',
					content: VM.shareImage.width,
				},
				{
					vmid: 'og:image:height',
					property: 'og:image:height',
					content: VM.shareImage.height,
				},
				{
					mid: 'og:site_name',
					property: 'og:site_name',
					content: pageTitle,
				},
				{
					mid: 'twitter:title',
					name: 'twitter:title',
					content: title,
				},
				{
					mid: 'twitter:description',
					name: 'twitter:description',
					content: VM.pageDescription,
				},
			],
		}
	},
}
</script>

<style lang="scss">
@import './assets/style.scss';
</style>
